/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';
import { DMCommonModule } from 'app/common/dm-common.module';

import { ExportService } from '../export.service';
import { StreamlineDiagnosticComponent } from './streamline-dianostic.component';
import { StreamlineDiagnosticService } from './streamline-dianostic.service';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        DMCommonModule,
        FormsModule,
    ],
    exports: [
        StreamlineDiagnosticComponent,
    ],
    declarations: [
        StreamlineDiagnosticComponent,
    ],
    providers: [
        ExportService,
        StreamlineDiagnosticService,
    ],
})
export class StreamlineDiagnosticModule { }
